<template>
    <div class="cabinet cabinet-supplier">
        <component :is="sideber" />

        <div class="cabinet-content">
            <vue-progress-bar></vue-progress-bar>

            <slot></slot>

            <cabinet-footer />
        </div>

        <notifications />
    </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import Notifications from 'vue-notification'

import PublicSidebar from '@/components/Public/Sidebar'
import RetailerNav from '@/components/Cabinet/Nav/RetailerNav'
import CabinetFooter from '@/components/Cabinet/Footer'

Vue.use(Notifications)

export default {
    name: 'DefaultLayout',

    components: {
        PublicSidebar,
        RetailerNav,
        CabinetFooter
    },

    computed: {
        ...mapGetters('user', ['isRetailer']),
        sideber() {
            return this.isRetailer ? RetailerNav : PublicSidebar
        }
    }
}
</script>
